var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeToggleOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0.333252C4.28498 0.333252 1.5714 5.23212 0.913066 6.63045C0.803066 6.86379 0.803066 7.13442 0.913066 7.36776C1.5714 8.76692 4.28498 13.6666 9.99998 13.6666C15.695 13.6666 18.4104 8.80237 19.0804 7.38403C19.1954 7.13987 19.1954 6.85997 19.0804 6.6158C18.4104 5.19747 15.695 0.333252 9.99998 0.333252ZM9.99998 2.83325C12.3008 2.83325 14.1666 4.69909 14.1666 6.99992C14.1666 9.30075 12.3008 11.1666 9.99998 11.1666C7.69915 11.1666 5.83331 9.30075 5.83331 6.99992C5.83331 4.69909 7.69915 2.83325 9.99998 2.83325ZM9.99998 4.49992C9.33694 4.49992 8.70105 4.76331 8.23221 5.23215C7.76337 5.70099 7.49998 6.33688 7.49998 6.99992C7.49998 7.66296 7.76337 8.29884 8.23221 8.76769C8.70105 9.23653 9.33694 9.49992 9.99998 9.49992C10.663 9.49992 11.2989 9.23653 11.7677 8.76769C12.2366 8.29884 12.5 7.66296 12.5 6.99992C12.5 6.33688 12.2366 5.70099 11.7677 5.23215C11.2989 4.76331 10.663 4.49992 9.99998 4.49992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeToggleOpen);
export default __webpack_public_path__ + "static/media/eye-toggle-open.da8279839f3e3d66940271de7fec6b4c.svg";
export { ForwardRef as ReactComponent };